import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { selectAdfoxPuids } from '../../../selectors/adfox';
import { getRegionId } from '../../../selectors/currentRegion';
import { TAdBannerCommonParameters } from '../../../types/adBannerMicrofrontend';
import { generateRandomString } from '../utils';

/**
 * Общие для всех мест параметры баннера: puids и регион из стора хоста плюс стабильный
 * идентификатор смонтированного баннера (`placeId`), по которому микрофронтенд шлёт
 * lifecycle-события и строит id adfox-контейнера.
 */
export function useAdBannerCommonParameters(): TAdBannerCommonParameters {
  const rawPuids = useSelector(selectAdfoxPuids, shallowEqual);
  const regionId = useSelector(getRegionId);

  const placeId = React.useMemo(() => generateRandomString(), []);

  const puids = React.useMemo(
    (): Record<string, string> =>
      Object.entries(rawPuids).reduce<Record<string, string>>((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = String(value);
        }

        return acc;
      }, {}),
    [rawPuids],
  );

  return React.useMemo((): TAdBannerCommonParameters => ({ placeId, puids, regionId }), [placeId, puids, regionId]);
}
